// extracted by mini-css-extract-plugin
export var childrenContainer = "_42-0";
export var virtualScrollArea = "_42-1";